import { useMemo } from "react";

/** True only for real demo app hosts - not app.dev / localhost / production. */
export function isDemoHostname(hostname: string): boolean {
    const host = hostname.toLowerCase();
    return host === "demo.patient-watch.com" || host.startsWith("demo.");
}

export function useDemo() {
    const isDemoEnvironment = useMemo(() => {
        if (typeof window === "undefined") return false;
        return isDemoHostname(window.location.hostname);
    }, []);

    return isDemoEnvironment;
}
